var map = {
	"./amharic.json": [
		367,
		367
	],
	"./english.json": [
		207,
		207
	],
	"./numbers.json": [
		421,
		421
	],
	"./oromifa.json": [
		132,
		132
	],
	"./words.json": [
		149,
		149
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 999;
module.exports = webpackAsyncContext;